import { render, staticRenderFns } from "./AppTaskCard.vue?vue&type=template&id=34fb77a6"
import script from "./AppTaskCard.vue?vue&type=script&lang=js"
export * from "./AppTaskCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports